import React, { useState } from 'react'
import { Row, Col } from 'react-bootstrap'
import {municipalities} from '../../../../../resources/location-codes.json'
import SearchContentField from '../../../../universal/search-content-field/search-content-field.component'
import MunicipalityTableRow from './table-row'

import './style.scss'

const Index = () => {

	const [searchQuery, setSearchQuery] = useState("");

	const searchList = e => {
        setSearchQuery(e.target.value);
	}

	return(
		<div>
			<div className="tab-content-container">
				<div className="all-locations-container">
					<SearchContentField searchQuery={searchQuery} handleSearch={searchList}/>
					<Row className="upper-information-row">
						<Col md={8}>
							<h3>Kommune</h3>
						</Col>
						<Col md={2} className="text-center">
							<h3>Kode</h3>
						</Col>
						<Col md={2} className="text-right">
							<h3>Innbyggere</h3>
						</Col>
					</Row>
						{Object.keys(municipalities).map((item, index, arr) => {
							if(!searchQuery){
								return(
									<MunicipalityTableRow municipalities={municipalities} item={item}/>
								)
							} else {
								if(municipalities[item].title.toLowerCase().includes(searchQuery.toLowerCase())){
									return(
										<MunicipalityTableRow municipalities={municipalities} item={item}/>
									)
								}
							}
						}
					)}
				</div>
			</div>
		</div>
	)
}

export default Index